import React, { Component } from 'react';
import './radio.scss';

export default class Radio extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { checked, iconPrefix = 'lf-radio', ...restProps } = this.props;

    return (
      <div className="lf-input-radio">
        <input type="radio" className="lf-radio-input" checked={checked} {...restProps} />
        <div className="lf-input-radio-content">
          <span className={[`${iconPrefix}-icon`, checked ? `${iconPrefix}-icon--checked` : ''].join(' ')}></span>
          {this.props.label}
        </div>
      </div>
    );
  }
}
